import useClickListener from "../../utils/hooks/useClickListener"

const DatalayerImageClick = props => {
  const datalayerImageClickHandler = event => {
    if (event?.target?.nodeName === "IMG") {
      let href = event?.target?.getAttribute("href") || null
      let buttonText =
        event?.target?.textContent || event?.target?.innerText || null

      /* Check if Link Appears in a Card or not */
      let isInCard = false
      var element = event?.target
      while (element.parentNode) {
        if (
          element.parentNode.className &&
          element.parentNode.className.includes("-card")
        ) {
          isInCard = true
        }
        element = element.parentNode
      }

      window.dataLayer.push({
        event: "img_link_click",
        click_label: buttonText, //label of button text
        click_url: href,
        click_media_src: event?.target?.src, //value within src attribute
        click_within_card: isInCard, //if click is within a card layout, true|false
        click_helper_text: buttonText,
        content_section: null,
        content_heading: null,
        content_subheading: null,
        content_eyebrow: null,
        content_date: null,
        content_author: null,
        content_category: null,
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query = document?.querySelectorAll("img").length > 0
  }
  useClickListener(datalayerImageClickHandler, query)
}

export default DatalayerImageClick
